export default {
    realtimemaps_landmark_list_showAll: "Show All",
    realtimemaps_landmark_list_hiddenAll: "Hide All",
};